module.exports = __webpack_public_path__ + "static/media/patient_risk_icon.a84b87f7.svg";